var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63143 2.97656H17.7078C20.7903 2.97656 23.2981 5.48433 23.298 8.56661V17.643C23.298 20.7253 20.7903 23.233 17.7078 23.233H8.63143C5.54915 23.233 3.0415 20.7254 3.0415 17.643V8.56661C3.0415 5.48433 5.54915 2.97656 8.63143 2.97656ZM17.7079 21.4357C19.7993 21.4357 21.5008 19.7343 21.5008 17.6429H21.5007V8.56657C21.5007 6.47528 19.7991 4.77377 17.7077 4.77377H8.63139C6.54011 4.77377 4.83871 6.47528 4.83871 8.56657V17.6429C4.83871 19.7343 6.54011 21.4358 8.63139 21.4357H17.7079ZM7.86494 13.1054C7.86494 10.18 10.2448 7.8 13.1702 7.8C16.0956 7.8 18.4755 10.18 18.4755 13.1054C18.4755 16.0307 16.0956 18.4105 13.1702 18.4105C10.2448 18.4105 7.86494 16.0307 7.86494 13.1054ZM9.69035 13.105C9.69035 15.023 11.2509 16.5834 13.1689 16.5834C15.0868 16.5834 16.6474 15.023 16.6474 13.105C16.6474 11.1869 15.087 9.62642 13.1689 9.62642C11.2508 9.62642 9.69035 11.1869 9.69035 13.105Z",
    fill: "#6B767F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_925_6370",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 21,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63143 2.97656H17.7078C20.7903 2.97656 23.2981 5.48433 23.298 8.56661V17.643C23.298 20.7253 20.7903 23.233 17.7078 23.233H8.63143C5.54915 23.233 3.0415 20.7254 3.0415 17.643V8.56661C3.0415 5.48433 5.54915 2.97656 8.63143 2.97656ZM17.7079 21.4357C19.7993 21.4357 21.5008 19.7343 21.5008 17.6429H21.5007V8.56657C21.5007 6.47528 19.7991 4.77377 17.7077 4.77377H8.63139C6.54011 4.77377 4.83871 6.47528 4.83871 8.56657V17.6429C4.83871 19.7343 6.54011 21.4358 8.63139 21.4357H17.7079ZM7.86494 13.1054C7.86494 10.18 10.2448 7.8 13.1702 7.8C16.0956 7.8 18.4755 10.18 18.4755 13.1054C18.4755 16.0307 16.0956 18.4105 13.1702 18.4105C10.2448 18.4105 7.86494 16.0307 7.86494 13.1054ZM9.69035 13.105C9.69035 15.023 11.2509 16.5834 13.1689 16.5834C15.0868 16.5834 16.6474 15.023 16.6474 13.105C16.6474 11.1869 15.087 9.62642 13.1689 9.62642C11.2508 9.62642 9.69035 11.1869 9.69035 13.105Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_925_6370)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.c43800b605941ef2a1fb3ea9b2633b89.svg";
export { ForwardRef as ReactComponent };